import { render, staticRenderFns } from "./BadgeBase.vue?vue&type=template&id=3e90b5bf&scoped=true&lang=pug&"
import script from "./BadgeBase.vue?vue&type=script&lang=js&"
export * from "./BadgeBase.vue?vue&type=script&lang=js&"
import style0 from "./BadgeBase.vue?vue&type=style&index=0&id=3e90b5bf&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e90b5bf",
  null
  
)

export default component.exports